(() => {
  const body = document.body;

  // Only run on the homepage
  if (!body.classList.contains('is-homepage')) {
    return;
  }

  // Create a background layer so we can fade it in
  const bg = document.createElement('div');
  bg.setAttribute('aria-hidden', 'true');
  Object.assign(bg.style, {
    position: 'fixed',
    inset: '0',
    zIndex: '-1',
    backgroundImage: 'none',
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
    opacity: '0',
    transition: 'opacity 180ms ease-out', // fade in quickly
    pointerEvents: 'none'
  });

  // Insert as the first child (so it sits behind content)
  body.prepend(bg);

  // Pick a random image
  const images = drupalSettings.backgroundImages;
  const url = images[Math.floor(Math.random() * images.length)];
  bg.style.backgroundImage = `url("${url}")`;

  // Trigger fade-in after it’s applied to ensure the transition runs
  requestAnimationFrame(() => {
    bg.style.opacity = '1';
  });
})();
